export interface IServiceCloudSettings {
    salesforceAccountId: string;
    loginId: string;
    globalUserId: string;
    persona: string;
    companyName: string;
    primaryContact: string;
    displayName: string;
    email: string;
    cellPhone: string;
    serviceCloudConfig: IServiceCloudConfig;
}

export class ServiceCloudSettings implements IServiceCloudSettings {
    constructor(data: Partial<IServiceCloudSettings> = {}) {
        this.salesforceAccountId = data.salesforceAccountId ?? "";
        this.loginId = data.loginId ?? "";
        this.globalUserId = data.globalUserId ?? "";
        this.persona = data.persona ?? "";
        this.companyName = data.companyName ?? "";
        this.primaryContact = data.primaryContact ?? "";
        this.displayName = data.displayName ?? "";
        this.email = data.email ?? "";
        this.cellPhone = data.cellPhone ?? "";
        this.serviceCloudConfig = data.serviceCloudConfig ?? {
            salesforceOrgId: "",
            channelName: "",
            channelEndpointUrl: "",
            channelJavaScriptSourceFileUrl: "",
            configurationFileUrl: "",
        };
    }
    salesforceAccountId: string;
    loginId: string;
    globalUserId: string;
    persona: string;
    companyName: string;
    primaryContact: string;
    displayName: string;
    email: string;
    cellPhone: string;
    serviceCloudConfig: IServiceCloudConfig;
}

interface IServiceCloudConfig {
    salesforceOrgId: string;
    channelName: string;
    channelEndpointUrl: string;
    channelJavaScriptSourceFileUrl: string;
    configurationFileUrl: string;
}

export class ServiceCloudConfig implements IServiceCloudConfig {
    constructor(data: IServiceCloudConfig) {
        this.salesforceOrgId = data.salesforceOrgId;
        this.channelName = data.channelName;
        this.channelEndpointUrl = data.channelEndpointUrl;
        this.channelJavaScriptSourceFileUrl = data.channelJavaScriptSourceFileUrl;
        this.configurationFileUrl = data.configurationFileUrl;
    }

    salesforceOrgId: string;
    channelName: string;
    channelEndpointUrl: string;
    channelJavaScriptSourceFileUrl: string;
    configurationFileUrl: string;
}
